import React, { createContext, useContext, useState } from "react";

const PageTitleContext = createContext(null);

export const PageTitleProvider = ({ children }) => {
  const [pageTitle, setPageTitle] = useState(null);
  const [parentPage, setParentPage] = useState(null);
  const [showBackButton, setShowBackButton] = useState(false);

  return (
    <PageTitleContext.Provider
      value={{ pageTitle, setPageTitle, parentPage, setParentPage, showBackButton, setShowBackButton }}
    >
      {children}
    </PageTitleContext.Provider>
  );
};

export const usePageTitle = () => {
  const context = useContext(PageTitleContext);
  if (!context) throw new Error("usePageTitle must be used within PageTitleProvider");
  return context;
};
